module.exports = "<h2><ng-content></ng-content></h2>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/HeadingComponent/heading.component.html
// module id = ./src/app/common/components/HeadingComponent/heading.component.html
// module chunks = main